import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Estadisticas from "../pages/estadisticas/page";
import Comunidad from "../pages/comunidad/page";
import Ligas from "../pages/ligas/page";
import Ranking from "../pages/ranking/page";
import Comparador from "../pages/comparador/page";
import Perfil from "../pages/perfil/page";
import Perfiles from "../pages/perfiles/page";
import Clasificacion from "../pages/clasificacion/page";
import ProtectedRoute from "../components/feature/ProtectedRoute";
import PagoExitoso from "../pages/pago-exitoso/page";
import Guia from "../pages/guia/page";
import JuegoResponsable from "../pages/juego-responsable/page";
import Terminos from "../pages/terminos/page";
import Privacidad from "../pages/privacidad/page";
import Cookies from "../pages/cookies/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/estadisticas", element: <ProtectedRoute><Estadisticas /></ProtectedRoute> },
  { path: "/clasificacion", element: <ProtectedRoute><Clasificacion /></ProtectedRoute> },
  { path: "/comunidad", element: <ProtectedRoute><Comunidad /></ProtectedRoute> },
  { path: "/ligas", element: <ProtectedRoute><Ligas /></ProtectedRoute> },
  { path: "/ranking", element: <ProtectedRoute><Ranking /></ProtectedRoute> },
  { path: "/comparador", element: <ProtectedRoute><Comparador /></ProtectedRoute> },
  { path: "/perfil", element: <ProtectedRoute><Perfil /></ProtectedRoute> },
  { path: "/perfiles/:id", element: <ProtectedRoute><Perfiles /></ProtectedRoute> },
  { path: "/perfiles", element: <ProtectedRoute><Perfiles /></ProtectedRoute> },
  { path: "/pago-exitoso", element: <ProtectedRoute><PagoExitoso /></ProtectedRoute> },
  { path: "/guia", element: <Guia /> },
  { path: "/juego-responsable", element: <JuegoResponsable /> },
  { path: "/terminos", element: <Terminos /> },
  { path: "/privacidad", element: <Privacidad /> },
  { path: "/cookies", element: <Cookies /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
